import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    SET_ACTION_LOG_TYPE: createActionType(FULL_NAMESPACE, "SET_ACTION_LOG_TYPE"),
    EXPORT: createActionType(FULL_NAMESPACE, "EXPORT"),
    GET_ACTION_LOG_EVENT_TYPE_DICTIONARY: createActionType(FULL_NAMESPACE, "GET_ACTION_LOG_EVENT_TYPE_DICTIONARY"),
    GET_ACTION_LOG_EVENT_TYPE_DICTIONARY_COMPLETED: createActionType(FULL_NAMESPACE, "GET_ACTION_LOG_EVENT_TYPE_DICTIONARY_COMPLETED"),
    GET_ACTION_LOG_EVENT_TYPE_DICTIONARY_REJECTED: createActionType(FULL_NAMESPACE, "GET_ACTION_LOG_EVENT_TYPE_DICTIONARY_REJECTED"),
    GET_ACTION_LOG_USERS: createActionType(FULL_NAMESPACE, "GET_ACTION_LOG_USERS"),
    GET_ACTION_LOG_USERS_COMPLETED: createActionType(FULL_NAMESPACE, "GET_ACTION_LOG_USERS_COMPLETED"),
    GET_ACTION_LOG_USERS_REJECTED: createActionType(FULL_NAMESPACE, "GET_ACTION_LOG_USERS_REJECTED"),
    GET_ACTION_LOG_PROJECTS: createActionType(FULL_NAMESPACE, "GET_ACTION_LOG_PROJECTS"),
    GET_ACTION_LOG_PROJECTS_COMPLETED: createActionType(FULL_NAMESPACE, "GET_ACTION_LOG_PROJECTS_COMPLETED"),
    GET_ACTION_LOG_PROJECTS_REJECTED: createActionType(FULL_NAMESPACE, "GET_ACTION_LOG_PROJECTS_REJECTED")
};
